import React from 'react';
import { FJ120 } from '../../../services/j202Api';
import { dateToInput, fmt } from '../helpers';
import LookupField from '../../../components/LookupField';

interface Tab1Props {
  formData: Partial<FJ120>;
  isEditing: boolean;
  getField: (key: keyof FJ120) => FJ120[keyof FJ120];
  setField: (key: keyof FJ120, value: FJ120[keyof FJ120]) => void;
}

const Tab1BasicInfo: React.FC<Tab1Props> = React.memo(({ formData, isEditing, getField, setField }) => {
  const isDisabled = !isEditing;

  return (
    <div className="j202-tab1">
      <div className="form-section">
        <span className="section-tag">基本資訊</span>
        <div className="form-grid">
          <label data-contract-field="fj120_01">樣品繳庫單號</label>
          <input type="text" readOnly value={getField('fj120_01') as string || ''} style={{ maxWidth: 120 }} />

          <label className="required" data-contract-field="fj120_10">樣品申請單</label>
          <LookupField
            lookupType="sample_request"
            maxLength={6}
            disabled={isDisabled}
            value={getField('fj120_10') as string || ''}
            onChange={v => setField('fj120_10', v)}
            onCodeConfirm={v => setField('fj120_10', v)}
            style={{ maxWidth: 120 }}
          />

          <label className="required" data-contract-field="fj120_11">繳庫日期</label>
          <input
            type="date"
            disabled={isDisabled}
            value={dateToInput(getField('fj120_11') as string | null)}
            onChange={e => setField('fj120_11', e.target.value ? e.target.value + 'T00:00:00Z' : null as unknown as string)}
            style={{ maxWidth: 160 }}
          />

          <label className="required" data-contract-field="fj120_12">繳庫庫位</label>
          <LookupField
            lookupType="warehouse"
            maxLength={5}
            disabled={isDisabled}
            value={getField('fj120_12') as string || ''}
            onChange={v => setField('fj120_12', v)}
            onCodeConfirm={v => setField('fj120_12', v)}
            style={{ maxWidth: 100 }}
          />

          <label data-contract-field="fj120_23">廠商代號</label>
          <LookupField
            lookupType="vendor"
            maxLength={12}
            disabled={isDisabled}
            value={getField('fj120_23') as string || ''}
            onChange={v => setField('fj120_23', v)}
            onCodeConfirm={v => setField('fj120_23', v)}
            style={{ maxWidth: 140 }}
          />
        </div>
      </div>

      <div className="form-section">
        <span className="section-tag">金額資訊</span>
        <div className="form-grid">
          <label data-contract-field="fj120_15">繳庫未稅金額</label>
          <input type="text" readOnly value={fmt(formData.fj120_15)} style={{ maxWidth: 150 }} />

          <label data-contract-field="fj120_16">稅額</label>
          <input type="text" readOnly value={fmt(formData.fj120_16)} style={{ maxWidth: 120 }} />

          <label data-contract-field="fj120_151">繳庫含稅金額</label>
          <input type="text" readOnly value={fmt(formData.fj120_151)} style={{ maxWidth: 150 }} />

        </div>
      </div>

      <div className="form-section">
        <span className="section-tag">備註</span>
        <div className="form-grid">
          <label data-contract-field="fj120_30">備註代號</label>
          <LookupField
            lookupType="remark"
            maxLength={2}
            disabled={isDisabled}
            value={getField('fj120_30') as string || ''}
            onChange={v => setField('fj120_30', v)}
            onCodeConfirm={v => setField('fj120_30', v)}
            style={{ maxWidth: 100 }}
          />

          <label data-contract-field="fj120_31">備註說明</label>
          <textarea
            disabled={isDisabled}
            value={getField('fj120_31') as string || ''}
            onChange={e => setField('fj120_31', e.target.value)}
            style={{ maxWidth: 400, minHeight: 60 }}
          />
        </div>
      </div>

      <div className="form-section">
        <span className="section-tag">人員資訊</span>
        <div className="form-grid">
          <label data-contract-field="fj120_18">申請人員</label>
          <input type="text" readOnly value={getField('fj120_18') as string || ''} style={{ maxWidth: 120 }} />

          <label data-contract-field="fj120_19">輸單人員</label>
          <input type="text" readOnly value={getField('fj120_19') as string || ''} style={{ maxWidth: 120 }} />
        </div>
      </div>
    </div>
  );
});

Tab1BasicInfo.displayName = 'Tab1BasicInfo';

export default Tab1BasicInfo;
